import React from "react";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../../assets/images/heylime-logo.png";
import { Auth } from "aws-amplify";
import gameReducer from "../../../redux/game/reducer";

const myTeamHeader = (props) => {
  const game_library = _.get(props, "gameReducer.gamesData.game_library") || "";
  const how_to_play = _.get(game_library, "how_to_play");
  const get_the_app = _.get(game_library, "get_the_app");
  const current_user = _.get(props, "gameReducer.currentUser");

  const handleTeamReports = () => {
    var cognitoUser = Auth.userPool.getCurrentUser();

    if (cognitoUser !== null && current_user?.team !== undefined) {
      props.history.push("/team-reports");
    } else {
      props.history.push("/no-team");
    }
  };

  return (
    <>
      <div className="game-select-head">
        <img onClick={() => props.history.push("/")} src={logo} alt="logo" />

        <div className="getapp-btn">
          <a href="https://www.gameapart.com/get-app" target="_blank">
            <button>Get App</button>
          </a>
          {/* <a href={get_the_app?.link} target="_blank">
              {get_the_app?.label}
            </a>
            <a href={how_to_play?.link} target="_blank">
              {how_to_play?.label}
            </a> */}
          {props.hideTeamReports === false ? (
            <div></div>
          ) : (
            <div className="nav">
              <a className="team-link" onClick={() => handleTeamReports()}>
                Team Reports
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

export default compose(withRouter, connect(mapStateToProps))(myTeamHeader);
